export const formatTextWithHighlightedVariables = (text?: string): string => {
	if (!text) {
		return '';
	}

	return text.replace(
		/{{([^}]+)}}/g,
		'<span class="bg-indigo-50 text-indigo-600 rounded px-1.5 mx-0.5 font-mono text-sm border border-indigo-100">{{$1}}</span>',
	);
};
